<template>
  <div class="main">
    <div class="daohang">
      <el-menu active-text-color="#ffd04b" background-color="#545c64" class="el-menu-vertical-demo" text-color="#fff"
        @open="handleOpen" @close="handleClose" :default-openeds="['1', '2']" :default-active="$route.path" router>
        <el-sub-menu index="1">
          <template #title>
            <el-icon>
              <location />
            </el-icon>
            <span>系统信息管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/admin/fileTree">资源树查询</el-menu-item>
            <el-menu-item index="/admin/files">文件管理</el-menu-item>
            <el-menu-item v-if="adminuser.level == 1" index="/admin/catalogInfo">目录管理</el-menu-item>
            <el-menu-item index="/admin/sourceInfo">资源管理</el-menu-item>
            <el-menu-item index="/admin/addSource">资源新增</el-menu-item>
          </el-menu-item-group>
        </el-sub-menu>

        <el-sub-menu index="2">
          <template #title>
            <el-icon>
              <location />
            </el-icon>
            <span>设置</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/">工具箱</el-menu-item>
            <el-menu-item index="logout" @click="out">退出登录</el-menu-item>
          </el-menu-item-group>
        </el-sub-menu>
      </el-menu>
    </div>
    <div class="xuanxiangka">
      <div style="width: 100%">
        <router-view></router-view>
        <!-- <DynamicContent :component="currentComponent" /> -->
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  name: "AdminHomeView",
  data() {
    return {
      role: sessionStorage.getItem("role"),
      zh: sessionStorage.getItem("usercode"),
      adminuser: JSON.parse(sessionStorage.getItem("adminuser")),
    };
  },
  mounted() {
  },
  methods: {
    out() {
      sessionStorage.removeItem("usercode");
      sessionStorage.removeItem("role");
      sessionStorage.setItem("s", false);
      this.$router.replace("/login");
    },
    goToolsHome() {
      this.$router.replace("/");
    },
    handleClick(row) {
      console.log(row);
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },

    handleMenuClick(component) {
      this.currentComponent = this.componentsMap[component];
    },
  },
};
</script>

